import './styles.css';
import { Game } from './game/Game';
import { Menu } from './ui/Menu';

const canvas = document.querySelector<HTMLCanvasElement>('#game-canvas')!;
const app = document.getElementById('app')!;
const game = new Game(canvas, { name: 'Pilot', shipId: 'challenger', color: 'blue' });
const menu = new Menu(app);
const wsUrl = import.meta.env.VITE_WS_URL ?? `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host}/ws`;
const mp = game.attachMultiplayer(wsUrl);
mp.onOnlineCount = (n) => menu.setOnline(n);
menu.onSound = (k) => game.audio.ui(k);
menu.onChange = (shipId, color) => void game.setShip(shipId, color);
menu.emitChange();
menu.onLaunch = (choice) => {
  void game.setShip(choice.shipId, choice.color).then(() => {
    menu.hide();
    game.launch(choice.name);
  });
};
game.onChangeShipRequest = () => {
  game.setMode('menu');
  game.spawn();
  menu.show();
};

const fill = document.getElementById('loading-fill')!;
const text = document.getElementById('loading-text')!;
game
  .load((done, total) => {
    fill.style.width = `${(done / total) * 100}%`;
    text.textContent = `Loading the solar system ${done}/${total}`;
  })
  .then(() => {
    document.getElementById('loading')!.classList.add('done');
    game.start();
    menu.show();
  });

// Playtest helpers
Object.assign(window, { __MENU__: menu });

if (import.meta.hot) import.meta.hot.dispose(() => game.dispose());
